// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ViewList from "@material-ui/icons/ViewList";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import { TransReactTable } from "components/CustomReactTable/TransReactTable";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";

// The recipient column depends on the kind of list; location is shown for both, because a room or
// table imported alongside the recipient is what tags their answer in the reports.
const columnsFor = (kind) => [{
  Header: "Title",
  accessor: "title"
},
{
  Header: "Name",
  accessor: "name"
},
kind === 'phone'
  ? { Header: "Phone", accessor: "phone" }
  : { Header: "Email", accessor: "email" },
{
  Header: "Location",
  accessor: "location"
},
{
  Header: "Action",
  accessor: "action"
}
];
const styles = {
  ...regularFormsStyle,
  ...sweetAlertStyle
};
class EmaillistTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: []
    };
  }
  componentDidMount() {
    this.renderEmail(this.props.emails)
  }
  componentDidUpdate(prevProps) {
    if (prevProps.emails !== this.props.emails) {
      this.renderEmail(this.props.emails)
    }
  }
  removeEmail = (key) => {
    const { t } = this.props

    if (!window.confirm(t('Are you sure?'))) return;
    let emails = this.state.emails;
    emails.splice(key, 1);
    this.props.removeEmail(emails)
  }
  renderEmail = (emails) => {
    const { t } = this.props
    let emailcomps = [];
    if (emails) {
      emailcomps = emails.map((item, key) => {
        return {
          ...item,
          action: <Button color="danger" size="sm" onClick={() => this.removeEmail(key)}>{t('Delete')}</Button>
        }
      })
    }
    this.setState({
      emails: emailcomps
    })

  }
  downloadCSV = () => {
    // Export the same columns the import expects, so a downloaded file can be edited and sent back.
    // The header row is what makes the download usable as a template: an empty list would otherwise
    // produce an empty file that says nothing about which columns to fill in. Both importers skip
    // it — the phone one requires a digit in the first column, the email one a valid address.
    const phone = this.props.kind === 'phone';
    const header = phone
      ? ['phone', 'title', 'name', 'location']
      : ['email', 'title', 'name', 'location'];
    const rows = this.state.emails.map((email) => {
      return phone
        ? [email.phone || '', email.title || '', email.name || '', email.location || '']
        : [email.email || '', email.title || '', email.name || '', email.location || '']
    })
    // A value holding a comma or quote has to be quoted, or it silently shifts every later column.
    const cell = (v) => {
      const s = String(v == null ? '' : v);
      return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    const csv = [header].concat(rows).map(r => r.map(cell).join(',')).join('\n');
    // A data: URI has to be percent-encoded, and encodeURI leaves # and & alone — both legal in a
    // name — so the file would truncate there. Build a Blob instead and let the browser save it.
    const filename = (phone ? 'phone_list' : 'email_list') + '.csv';
    try {
      const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });   // BOM: Excel reads Greek
      if (window.navigator && window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename);
        return;
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      window.open('data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
    }
  }


  render() {
    const { classes, t } = this.props;
    return (
      <div>
        {this.state.alert}
        <Card className={classes.zeroZindex}>
          <CardHeader color="success" icon>
            <CardIcon color="success">
              <ViewList />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {this.props.kind === 'phone' ? t('Phone numbers') : t('E-mails')}
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12}>
                <Button
                  size="sm"
                  color="danger"
                  onClick={() => {
                    this.props.addEmail();
                  }}
                >
                  {this.props.kind === 'phone' ? t('Add new phone in list') : t('Add new email in list')}
                </Button>

                <Button size="sm" color="info" onClick={() => { this.downloadCSV() }}>{t('Download CSV')}</Button>
                <Button size="sm" color="info" onClick={() => { this.props.uploadCSV() }}>{t('Upload CSV')}</Button>
              </GridItem>
              <GridItem xs={12} sm={12}>
                <TransReactTable
                  defaultPageSize={20}
                  data={this.state.emails}
                  columns={columnsFor(this.props.kind)}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    );
  }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
  withTranslation()(withStyles(styles, { withTheme: true })(EmaillistTable))
);
